import {alertActions} from "./alertActions";
import {automationRulesConstants} from "../constants/automationRulesConstants";
import {automationRulesServices} from "../../service/automationRulesService";

export const automationRulesAction = {
    read,
    readMoreRows,
    findRule,
    updateRule,
    updateRuleStatus,
    updateOrderBy,
    updateSortBy,
    updateSortColumns,
    createRule,
    stopLoading,
    deleteRule,
    closeForm
};

function read(domain, page, orderBy, sortBy, workspace) {
    return (dispatch) => {
        dispatch({type: automationRulesConstants.AUTOMATION_RULES_SET_IS_LOADING});
        dispatch(alertActions.error(""));
        automationRulesServices.read({page, orderBy, sortBy, workspace})
            .then((result) => {
                dispatch({type: automationRulesConstants.AUTOMATION_RULES_LOADING, result});
            }).catch((error) => {
                dispatch({type: automationRulesConstants.AUTOMATION_RULES_LOADING_ERROR, error});
                dispatch(alertActions.error(error?.response?.data?.error));
            }
        );
    };
}

function readMoreRows(domain, page, orderBy, sortBy, workspace) {
    return (dispatch) => {
        dispatch({type: automationRulesConstants.AUTOMATION_RULES_SET_IS_LOADING});
        dispatch(alertActions.error(""));
        automationRulesServices.read({page, orderBy, sortBy, workspace})
            .then((result) => {
                dispatch({type: automationRulesConstants.AUTOMATION_RULES_INFINITY_SCROLL, result});
            }).catch((error) => {
                dispatch({type: automationRulesConstants.AUTOMATION_RULES_LOADING_ERROR, error});
                dispatch(alertActions.error(error?.response?.data?.error));
            }
        );
    };
}

function createRule({formData, trafficSourceName, workspaceName}) {
    return (dispatch) => {
        dispatch({type: automationRulesConstants.AUTOMATION_RULES_SET_IS_LOADING});
        dispatch(alertActions.error(""));
        automationRulesServices.create(formData)
            .then((result) => {

                // Additional data mapping
                result.trafficSourceName = trafficSourceName;
                result.workspaceName = workspaceName;

                dispatch({type: automationRulesConstants.AUTOMATION_RULES_ADD_RULE, payload: result});
            }).catch((error) => {
                dispatch({type: automationRulesConstants.AUTOMATION_RULES_LOADING_ERROR, error});
                dispatch(alertActions.error(error?.response?.data?.error));
            }
        );
    };
}

function deleteRule({ruleId}) {
    return (dispatch) => {

        if (ruleId === 0) {
            dispatch(alertActions.error("Invalid rule ID"));
            return false;
        }

        dispatch({type: automationRulesConstants.AUTOMATION_RULES_SET_IS_LOADING});
        dispatch(alertActions.error(""));
        automationRulesServices.remove({ruleId})
            .then((result) => {
                dispatch(alertActions.success("Rule ID: " + ruleId + "; has been deleted successfully."));
                dispatch({type: automationRulesConstants.AUTOMATION_RULES_DELETE_RULE, payload: {ruleId}});
            }).catch((error) => {
                dispatch({type: automationRulesConstants.AUTOMATION_RULES_LOADING_ERROR, error});
                dispatch(alertActions.error(error?.response?.data?.error));
            }
        );
    };
}

function findRule(id) {
    return (dispatch) => {

        if (id === 0) {
            dispatch(alertActions.error("Invalid rule ID"));
            return false;
        }

        dispatch({type: automationRulesConstants.AUTOMATION_RULES_SET_IS_LOADING});
        dispatch(alertActions.error(""));
        automationRulesServices.find(id)
            .then((result) => {
                dispatch({type: automationRulesConstants.AUTOMATION_RULES_FIND_RULE, payload: result});
            }).catch((error) => {
                dispatch({type: automationRulesConstants.AUTOMATION_RULES_LOADING_ERROR, error});
                dispatch(alertActions.error(error?.response?.data?.error));
            }
        );
    };
}

function updateOrderBy(orderBy) {
    return (dispatch) => {
        dispatch({type: automationRulesConstants.AUTOMATION_RULES_UPDATE_ORDER_BY, orderBy});
    };
}

function updateSortBy(sortBy) {
    return (dispatch) => {
        dispatch({type: automationRulesConstants.AUTOMATION_RULES_UPDATE_SORT_BY, sortBy});
    };
}

function updateRule({ruleId, formData, trafficSourceName, workspaceName}) {
    return (dispatch) => {
        dispatch({type: automationRulesConstants.AUTOMATION_RULES_SET_IS_LOADING});
        dispatch(alertActions.error(""));
        automationRulesServices.update({id: ruleId, formData})
            .then((result) => {
                dispatch({type: automationRulesConstants.AUTOMATION_RULES_UPDATE_RULE, payload: {result, trafficSourceName, workspaceName}});
            }).catch((error) => {
                dispatch({type: automationRulesConstants.AUTOMATION_RULES_LOADING_ERROR, error});
                dispatch(alertActions.error(error?.response?.data?.error));
            }
        );
    };
}

function updateRuleStatus({ruleId, status, trafficSourceId, workspaceId}) {
    return (dispatch) => {

        if (ruleId === 0) {
            dispatch(alertActions.error("Invalid rule ID"));
            return false;
        }

        dispatch({type: automationRulesConstants.AUTOMATION_RULES_SET_IS_LOADING});
        dispatch(alertActions.error(""));

        automationRulesServices.update({id: ruleId, formData: {status: status ? "active" : "paused", trafficSourceId, workspaceId}})
            .then((result) => {
                dispatch(alertActions.success("Rule ID: " + ruleId + "; status updated successfully."));
                dispatch({type: automationRulesConstants.AUTOMATION_RULES_UPDATE_RULE_STATUS, payload: {ruleId, status}});
            }).catch((error) => {
                dispatch({type: automationRulesConstants.AUTOMATION_RULES_LOADING_ERROR, error});
                dispatch(alertActions.error(error?.response?.data?.error));
            }
        );
    };
}

function updateSortColumns(sortColumns) {
    return (dispatch) => {
        dispatch({type: automationRulesConstants.AUTOMATION_RULES_UPDATE_SORT_COLUMNS, sortColumns});
    };
}

function closeForm() {
    return (dispatch) => {
        dispatch({type: automationRulesConstants.AUTOMATION_RULES_CLOSE_FORM});
    };
}

function stopLoading() {
    return dispatch => {
        dispatch({type: automationRulesConstants.AUTOMATION_RULES_STOP_LOADING});
    };
}
